import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import EvolutionCard from '../../../../Components/EvolutionCard'
import WTypography from '../../../../Components/whiteTypography'
import { makeGetRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'
import BarChart from './BarChart'
import DonutChart from './DonutChart'
import Filters from './Filters'
import OperationTable from './OperationTable'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import { setAppStore } from 'reduxLib/slices/mainAppSlice'
import { deviseCal } from 'utils/helpers'
import LineChart from './LineChart'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

function RevenusDespense() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const getAppStore = useSelector((store) => store.appStore).appStore
  const siteDevise = useSelector((store) => store.devise)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { slug } = params
  const query = useQuery()
  const [operationsDashboard, setOperationsDashboard] = useState({})
  const [tableLoading, setTableLoading] = useState(false)
  const [donutData, setDonutData] = useState({})
  const [barData, setBarData] = useState({
    labels: [],
    datasets: [
      {
        label: slug === 'D' ? t('dashboardDetail.expenses') : t('dashboardDetail.income'),
        data: [],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
      },
    ],
  })
  const location = useLocation()

  const [barHeaderValue, setBarHeaderValue] = useState(0)
  const [evolutionsData, setEvolutionsData] = useState({})

  useEffect(() => {
    // Refetch all data when currency changes to get backend-converted values
    const queryString = query.toString()
    console.log('Currency changed, refetching with query:', queryString)
    fetchDashboardDonutChart(queryString) // This will also update the bar chart
    fetchDashboardOperations('', false, queryString)
  }, [siteDevise])
  useEffect(() => {
    // fetchDashboardDonutChart(query)
    // fetchDashboardDetailsChartRevoBar(location.search.slice(1))
    // fetchDashboardOperations()
    fetchDashboardDetailsEvolutions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    console.log(query.toString())
    if (query.get('view')) {
      query.set('view', getAppStore.viewType)
    } else {
      query.append('view', getAppStore.viewType)
    }
    
    if (query.get('type')) {
      query.set('type', getAppStore.type)
    } else {
      query.append('type', getAppStore.type)
    }
    
    navigate('?' + query.toString())
    
    // Immediately refetch data with new view type
    if (query.size > 0) {
      const queryString = query.toString()
      fetchDashboardDonutChart(queryString) // This will also update the bar chart
      fetchDashboardOperations('', false, queryString)
    }
  }, [getAppStore])
  // console.log(query)
  useEffect(() => {
    if (query.size > 0) {
      fetchDashboardDonutChart(query.toString()) // This will also update the bar chart
      fetchDashboardOperations('', false, query.toString())
    }
  }, [query])
  // console.log(location.search)

  const fetchDashboardOperations = async (params = '', pagination = false, queryp = '') => {
    setTableLoading(true)
    // Add currency parameter to the request
    const currencyParam = `&currency=${siteDevise.devise.Code_iso}`
    let url = `${urls.crudDashboardDetailsOperations}?type_operation=${slug}&${params}&${queryp}${currencyParam}`
    if (pagination && location.search !== '') {
      url = `${
        urls.crudDashboardDetailsOperations
      }?type_operation=${slug}&limit=${params}&${location.search.slice(1)}&${queryp}${currencyParam}`
    } else if (pagination) {
      url = `${urls.crudDashboardDetailsOperations}?type_operation=${slug}&limit=${params}&${queryp}${currencyParam}`
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperationsDashboard({ ...response.data })
      setTableLoading(false)
    } else {
      setTableLoading(false)
    }
  }

  const fetchDashboardDonutChart = async (params = '') => {
    let calcul = 'revenus.js'
    if (slug === 'D') {
      calcul = 'depenses.js'
    }
    // Add currency parameter to the request
    const currencyParam = `&currency=${siteDevise.devise.Code_iso}`
    // Add type_view parameter to properly group data
    const viewParam = getAppStore.viewType ? `&type_view=${getAppStore.viewType}` : ''
    let url = `${urls.fetchDashboardDetailsDonutChart}${'general'}/?calcul=${calcul}&${params}${currencyParam}${viewParam}`

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setDonutData({ ...response.data })
      // Update bar chart to show categories/subcategories/accounts
      updateBarChartFromDonutData(response.data)
    }
  }

  const fetchDashboardDetailsChartRevoBar = async (params = '') => {
    let labels = []
    let data = []
    // Add currency parameter to the request
    const currencyParam = `&currency=${siteDevise.devise.Code_iso}`
    let url = `${urls.fetchDashboardDetailsChartRevoBar(slug)}/?${params}${currencyParam}`
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setBarHeaderValue(response.data.general_montant)
      response.data.data.map((cat, i) => {
        labels.push(cat.date)
        data.push(cat.montant)
        return ''
      })
      // No need for frontend conversion - backend now returns converted values
      setBarData({
        labels: [...labels],
        datasets: [
          {
            label: slug === 'D' ? t('dashboardDetail.expenses') : t('dashboardDetail.income'),
            data: [...data],
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
          },
        ],
      })
    }
  }
  
  // Update bar chart data from donut chart data (categories/subcategories)
  const updateBarChartFromDonutData = (donutResponse) => {
    if (donutResponse && donutResponse.calculation && donutResponse.calculation.group_of_categories) {
      let labels = []
      let amounts = []
      
      donutResponse.calculation.group_of_categories.forEach((cat) => {
        labels.push(cat.name)
        amounts.push(parseFloat(cat.aggregate).toFixed(2))
      })
      
      setBarData({
        labels: labels,
        datasets: [
          {
            label: slug === 'D' ? t('dashboardDetail.expenses') : t('dashboardDetail.income'),
            data: amounts,
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c', '#1e3a5f', '#4a7ba7', '#5d9bd5'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c', '#1e3a5f', '#4a7ba7', '#5d9bd5'],
            borderWidth: 1,
          },
        ],
      })
      
      setBarHeaderValue(donutResponse.calculation.header_value)
    }
  }
  const fetchDashboardDetailsEvolutions = async (e) => {
    const response = await makeGetRequest(urls.fetchDashboardDetailsEvolutions(slug), {}, true)
    if (response.status === 200) {
      setEvolutionsData({ ...response.data })
    }
  }
  return (
    <Grid container spacing={2}>
      {(getAppStore.table === 1 || getAppStore.table === 2) && (
        <>
          {/* <Grid item md={2}>
            <Filters
              donutApi={fetchDashboardDonutChart}
              revoApi={fetchDashboardDetailsChartRevoBar}
              accountTypes={evolutionsData}
              operationApi={fetchDashboardOperations}
            />
          </Grid> */}
          {/* <Box className={getAppStore.expandChart ? 'expand_chart' : 'height-500'}> */}
          <Grid
            item
            md={12}
            container
            spacing={2}
            className={getAppStore.expandChart ? 'expand_chart' : ''}
          >
            {getAppStore.expandChart && (
              <CloseIcon
                onClick={() => dispatch(setAppStore({ expandChart: false }))}
                sx={{
                  color: 'white',
                  cursor: 'pointer',
                  position: 'absolute',
                  right: '60px',
                  top: '40px',
                }}
              />
            )}
            {getAppStore.chart === 1 && (
              <Grid item md={12}>
                <BarChart
                  slug={slug}
                  barData={barData}
                  barHeaderValue={barHeaderValue}
                  setData={fetchDashboardDetailsChartRevoBar}
                />
              </Grid>
            )}
            {getAppStore.chart === 2 && (
              <Grid item md={12}>
                <LineChart
                  slug={slug}
                  barData={barData}
                  barHeaderValue={barHeaderValue}
                  setData={fetchDashboardDetailsChartRevoBar}
                />
              </Grid>
            )}
            {getAppStore.chart === 3 && (
              <Grid item md={12}>
                <DonutChart slug={slug} data={donutData} setData={fetchDashboardDonutChart} />
              </Grid>
            )}
            {/* <Grid item md={12}>
              <Box display={'flex'} justifyContent="space-between">
                <EvolutionCard data={evolutionsData.EvolM1} text={'Evolution M-1'} width="33%" />
                <EvolutionCard data={evolutionsData.EvolN1} text={'Evolution N-1'} width="33%" />
                <EvolutionCard
                  data={evolutionsData.SourceRev}
                  text={'Sources de revenus'}
                  width="33%"
                />
              </Box>
            </Grid> */}
          </Grid>
          {/* </Box> */}
        </>
      )}
      {(getAppStore.table === 1 || getAppStore.table === 3) && (
        <Grid item sm={12} className="rounded" p={1} mt={3}>
          <Box
            display="flex"
            bgcolor={'#001b42'}
            p={2}
            className="rounded"
            justifyContent="space-between"
          >
            <WTypography>{t('dashboardDetail.operationsCreditors')}</WTypography>
            <WTypography>
              {operationsDashboard.count === 0 ? t('dashboardDetail.noData') : operationsDashboard.count}
            </WTypography>
          </Box>

          <OperationTable
            fetchOperations={fetchDashboardOperations}
            operations={operationsDashboard}
            // loading={tableLoading}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default RevenusDespense
